import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=5ecd1a33&scoped=true"
import script from "./ProductThumbnail.vue?vue&type=script&lang=js"
export * from "./ProductThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ProductThumbnail.vue?vue&type=style&index=0&id=5ecd1a33&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd1a33",
  null
  
)

export default component.exports